<template>
  <div>
    <nav-breadcrumb :menu="[{label: '管理'}]"/>
    <div class="bg-purple xzpadd10">
      <data-table
        :tableData="customerListData"
        :columns="customerListColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters.sync="filters"
        :actions="actions"
      ></data-table>
    </div>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import Status2CN from "../../../filters/Status2CN";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'CustomerList',
    data() {
      return {
        page: 1,
        pageSize: 10,
        customerListData: {},
        customerListColumns: [
          {
            name: '客户编号',
            field: 'u__customerCode'
          },
          {
            name: '客户姓名',
            field: 'u__customerName'
          },
          {
            name: '手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '身份证号码',
            field: 'i__socialIdentityCode'
          },
          // {
          //   name: '所属行业',
          //   field: 'i__industry'
          // },
          // {
          //   name: '法人代表',
          //   field: 'i__bizrep'
          // },
          {
            name: '建档时间',
            field: 'cr__createdDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD hh:mm')
            }
          },
          {
            name: '授信额度(元)',
            field: 'cr__lineOfCredit',
            formatter:  (r,c,v)=> {
              return formatMoney(v)
            }
          },
          {
            name: '占用额度(元)',
            field: 'cr__useCredit',
          /*  formatter:  (r,c,v)=> {
              return formatMoney(this.subtrValue(r.cr__lineOfCredit , r.cr__creditBalance))
            }*/
          },
          {
            name: '可用额度(元)',
            field: 'cr__creditBalance',
            formatter:  (r,c,v)=> {
              return formatMoney(v)
            }
          },
          {
            name: '账户余额(元)',
            field: 'cr__accountBalance',
            /*formatter:  (r,c,v)=> {
              if( this.subtrValue( r.cr__creditBalance,r.cr__lineOfCredit)>0){
                return formatMoney(this.subtrValue( r.cr__creditBalance,r.cr__lineOfCredit))
              }else{
                return '0.00'
              }

            }*/
          },
          {
            name: '操作',
            opts:[
             /* {
                class: 'el-icon-edit',
                name: '编辑客户',
                clickHandler: (index, row)=>{
                  this.$router.push({
                    path: '/pages/CustomerAdmin/Customer/Edit',
                    query: {
                      'c.customerId' : row.c__customerId
                    }
                  })
                }
              },*/
              {
                class: 'el-icon-info',
                name: '交易记录',
                clickHandler: (index, row)=>{
                  this.viewDetail(index, row)
                }
              }
            ]
          }
        ],
        filters: {
          form: {
            c__customerId: '',
            c__customerName: '',
            i__socialIdentityCode: '',
            c__createdDate: [],
            i__bizrep: ''
          },
          columns: [
            {
              label: '客户编号',
              component: 'el-input',
              field: 'u__customerCode'
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'c__customerName'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'i__contactTelNo'
            },
            /*{
              label: '注册日期',
              component: 'date-range-picker',
              field: 'c__createdDate',
              op:['gteq','lteq']
            },*/
            {
              label: '身份证号码',
              component: 'el-input',
              field: 'i__socialIdentityCode'
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerCreditList()
          }
        },
        actions: [
          {
            label: '导出',
            class: 'el-icon-download el-button--primary',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/customer/CustomerCredit.List?format=xlsx',
                query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ]
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'c.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerCreditList()
      }
    },
    mounted() {
      this.getCustomerCreditList()
    },
    components: {
    },
    methods: {
      getCustomerCreditList: function () {
        xhr.getCustomerCreditList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
          try {
            this.customerListData = res.data
          }catch(e){

          }
        })

      },
      subtrValue:function(arg1, arg2){
        var r1, r2, m, n;
             try {
                   r1 = arg1.toString().split(".")[1].length;
               }
             catch (e) {
                   r1 = 0;
               }
             try {
                   r2 = arg2.toString().split(".")[1].length;
               }
             catch (e) {
                   r2 = 0;
               }
             m = Math.pow(10, Math.max(r1, r2));
              //last modify by deeka
              //动态控制精度长度
             n = (r1 >= r2) ? r1 : r2;
             return ((arg1 * m - arg2 * m) / m).toFixed(n);
      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({
            path: 'CashJournalList?c.customerId='+row.cr__customerId
          })
        }
        catch (e) {

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/CustomerList.vue